export default __webpack_public_path__ + "static/media/casa.7824f7a5.svg";